/**
 * 入力制限に関する定数
 */

/** 画像アップロードのファイルサイズ上限（MB） */
export const MAX_UPLOAD_FILE_SIZE_MB = 10;

/** 画像アップロードのファイルサイズ上限（バイト） */
export const MAX_UPLOAD_FILE_SIZE_BYTES = MAX_UPLOAD_FILE_SIZE_MB * 1024 ** 2;

/** テキスト入力の最大文字数 */
export const MAX_TEXT_INPUT_LENGTH = 5000;
